import { ReactComponent as CopyMonkeyLogo } from '../../../assets/images/logo.svg';
import Introduction from './Introduction';
import { Container, FormContainer, IntroductonContainer } from './styled';
import { Signup } from './forms/Signup';
import { Signin } from './forms/Signin';
import { ForgotPassword } from './forms/ForgotPassword';
import { ChangePassword } from './forms/ChangePassword';
import { ConfirmEmail } from './forms/ConfirmEmail';
import { useAppSelector, useCheckIsUserAuthorized } from '../../../hooks';
import { useNavigate } from 'react-router-dom';
import { PATHS } from '../../../constants/routes';
import { AuthForm } from '../../../types/auth';

declare global {
  interface Window {
    ymGlobal: any;
  }
}

const formComponent: Record<AuthForm, () => JSX.Element> = {
  [AuthForm.Signup]: Signup,
  [AuthForm.Signin]: Signin,
  [AuthForm.ConfirmEmail]: ConfirmEmail,
  [AuthForm.ForgotPassword]: ForgotPassword,
  [AuthForm.ChangePassword]: ChangePassword,
};

const AuthPage = () => {
  const navigate = useNavigate();
  const { type } = useAppSelector((state) => state.cognito);

  const renderAuthForm = () => {
    const FormComponent = formComponent[type];
    return <FormComponent />;
  };

  const { isUserAuthorizedChecking } = useCheckIsUserAuthorized(() => navigate(PATHS.dashboard));

  if (isUserAuthorizedChecking) {
    return null;
  }

  return (
    <Container>
      <FormContainer>
        <CopyMonkeyLogo />

        {renderAuthForm()}
      </FormContainer>

      <IntroductonContainer>
        <Introduction tab={1} />
      </IntroductonContainer>
    </Container>
  );
};

export default AuthPage;
